import { useFrame, useLoader } from "@react-three/fiber";
import { useRef } from "react";

import earthTexture from "../../assets/earth-texture.jpg";
import yescatImg from "../../assets/yescat.png";
import nocatImg from "../../assets/nocat.png";

import { TextureLoader } from "three";
import { OrbitControls } from "@react-three/drei";
import Cat from "./Cat";

const Earth = ({ onNoCatClick, onYesCatClick, hideYesCat }) => {
  const earthRef = useRef();

  const texture = useLoader(TextureLoader, earthTexture);

  useFrame(() => {
    if (earthRef.current) {
      earthRef.current.rotation.y += 0.002;
    }
  });

  return (
    <>
      <group ref={earthRef}>
        <mesh>
          <sphereGeometry args={[1, 128, 128]} />
          <meshBasicMaterial map={texture} />
        </mesh>
        <Cat textureUrl={yescatImg} hidden={hideYesCat} onExtraClick={onYesCatClick} />
        <Cat textureUrl={nocatImg} shrinks onExtraClick={onNoCatClick} />
      </group>
      <OrbitControls
        minDistance={2}
        maxDistance={6}
        enableZoom={true}
        dampingFactor={0.1}
      />
    </>
  );
};

export default Earth;
